import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconThumbsUp: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="thumbs-up, thumb, hand, yes, pro"><path fillRule="evenodd" clipRule="evenodd" d="M11 2C10.7192 2 10.4619 2.15688 10.3333 2.40653L6.42148 10H2.75C2.33579 10 2 10.3358 2 10.75V20.25C2 20.6642 2.33579 21 2.75 21H17.422C19.2752 21 20.8505 19.6463 21.1293 17.8142L21.9663 12.3142C22.3117 10.0444 20.5548 8 18.2589 8H13.8921L14.3328 5.17364C14.5928 3.50611 13.3033 2 11.6156 2H11ZM6 11.5V19.5H3.5V11.5H6Z" fill="currentColor"/></CentralIconBase>;
};

export default IconThumbsUp;
